import { createContext, useContext } from 'react';

import useLocationExitPath from '@app/hooks/useLocationExitPath';

const INITIAL_STATE = undefined;

const ExitPathContext = createContext<string | undefined>(INITIAL_STATE);

export function ExitPathContextProvider({ children }: { children: React.ReactNode }) {
  const { exitPath } = useLocationExitPath();

  return <ExitPathContext.Provider value={exitPath}>{children}</ExitPathContext.Provider>;
}

export function useExitPathContext() {
  return useContext(ExitPathContext);
}
